<template>
    <form @submit.prevent="search" class="k-search">
        <input type="text" class="k-search__input" :placeholder="placeholder" v-model="searchedValue">
        <button class="k-search__button">
            <svg role="img" width="18" height="18">
                <use fill="currentColor" xlink:href="/images/spritesheet.svg#magnify-glass"></use>
            </svg>
        </button>
    </form>
</template>

<script>
    export default {
        props:{
            placeholder: {
                type: String,
                default: 'Zadejte klíčové slovo nebo frázi'
            }
        },
        data: function () {
            return {
                searchedValue: ''
            }
        },
        methods: {
            /**
             * Emit search event
             */
            search: function() {
                window.events.$emit('searchInputSubmitted', this.searchedValue);
            }
        },
    }
</script>
